import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/Mayhem.png";

export const mayhemInManchesterDetail = {
  "mayhem-in-manchester": {
    id: "mayhem-in-manchester",
    title: "Mayhem in Manchester",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "mayhem-in-manchester",
        items: [
          {
            id: "mayhem-in-manchester-1",
            title: "Mayhem in Manchester",
            description: "Manchester, England 1998",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
